import { capitalize } from 'lodash';

import { InputAddressAutocompleteAddress } from 'src/general/components/forms/FormikInputAddressAutocomplete/FormikInputAddressAutocomplete';

export const formatPhoneNumber = (phoneNumber?: string) => {
  if (phoneNumber) {
    return phoneNumber.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
  }
  return '';
};

export const formatName = (firstName: string, lastName: string) => `${firstName} ${lastName}`;

export const formatAddress = (address: InputAddressAutocompleteAddress | undefined): string => {
  if (!address) {
    return '';
  }
  const { apartment, street, state, suburb, postcode } = address;
  const apartmentResult = apartment ? `${capitalize(apartment)}, ` : '';
  return `${apartmentResult}${street}, ${suburb} ${state} ${postcode}`;
};

export const removeLeadingSlashFromUrl = (url: string) => {
  return url.startsWith('/') ? url.slice(1) : url;
};

export const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(() => resolve(), ms));
